import { h, JSX, ComponentFactory } from 'preact'
import { Icon } from '../Icons/Icons'
import cx from 'classnames'
import { Message } from '../../../../lib/intl/Message'
import { SwipeContainerCustomElementName } from './custom-element'

import styles from './Swipe.module.css'

const SwipeContainer = ({ ...rest }: JSX.HTMLAttributes) => {
  return h(SwipeContainerCustomElementName, {
    ...rest
  })
}

interface ButtonProps extends JSX.HTMLAttributes {
  direction: 'right' | 'left'
  showing?: boolean
  onClick?: JSX.EventHandler<Event>
}

type DotIndicatorsProps = { length: number }

type Props = {
  items: JSX.Element[]
  button?: ComponentFactory<ButtonProps>
  dotIndicators?: ComponentFactory<DotIndicatorsProps>
  class?: string
  className?: string
  style?: any
}

export function Swipe({ items, button, dotIndicators, class: c, className, style }: Props) {
  const Button = button || DefaultButton
  const DotIndicators = dotIndicators || DefaultDotIndicators
  const showRightButton = items && items.length > 1

  return (
    <SwipeContainer class={cx(styles.wrapper, className, c)} style={style}>
      <Button direction="left" data-button-hidden="true" />
      <Button direction="right" data-button-hidden={showRightButton ? 'false' : 'true'} />
      <div class={styles.fullWidthContainer}>
        <div class={styles.scrollContainer} data-scroll-container="true">
          <div class={styles.spacer} />
          {items}
          <div class={styles.spacer} />
        </div>
      </div>
      <DotIndicators length={items.length} />
    </SwipeContainer>
  )
}

export function SwipeItem({ children, class: c, className, ...rest }: JSX.HTMLAttributes) {
  const classes = cx(styles.scrollItem, c, className)
  return (
    <div class={classes} {...rest}>
      {children}
    </div>
  )
}

function DefaultButton({ direction, showing, ...rest }: ButtonProps) {
  if (direction === 'left') {
    return (
      <button class={styles.left} {...rest}>
        <Icon type="nrk-arrow-left" />
        <Message id="rull-til-venstre" class="nrk-sr" />
      </button>
    )
  } else {
    return (
      <button class={styles.right} {...rest}>
        <Icon type="nrk-arrow-right" />
        <Message id="rull-til-hoyre" class="nrk-sr" />
      </button>
    )
  }
}

function DefaultDotIndicators({ length }: DotIndicatorsProps) {
  if (length <= 1) {
    return null
  }
  return (
    <div class={styles.dots} data-scroll-indicator="true">
      {Array(length)
        .fill('')
        .map((_, idx) => (
          <span class={styles.dot} data-indicator-active={idx === 0 ? 'true' : 'false'} />
        ))}
    </div>
  )
}
